import { Loading } from 'components/basic/loading';
import { Overlay } from 'components/basic/overlay';
import { useGetLogParameter } from 'feature/logParameter';
import { useEffect } from 'react';
import { Button } from '../basic/button';

interface openJsonPageButtonProps {
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
  margin?: number;
  id: string;
  ioFlg: string;
}
export const OpenJsonPageButton = (props: openJsonPageButtonProps) => {
  const {
    disabled = false,
    className,
    margin = 10,
    children,
    id,
    ioFlg,
  } = props;
  const [getLogParameter, logParameter, loading, error] = useGetLogParameter();

  const handleGetLogParameter = async () => {
    // 実行ログ情報を取得
    await getLogParameter(id, ioFlg);
  };

  // handleGetLogParameterが呼ばれた場合の別タブ表示処理
  useEffect(() => {
    // 初期値が設定されている場合は処理しない
    if (logParameter === undefined && error === false) return;

    const newTab = window.open();
    if (!error) {
      let p = document.createElement('p');
      // 整形したJSONをテキストノードとしてHTMLElementへ追加
      p.appendChild(
        document.createTextNode(
          JSON.stringify(JSON.parse(logParameter![0].logParameter), null, 2),
        ),
      );

      newTab?.document.write(`<pre>${p.innerHTML}</pre>`);
    } else {
      newTab?.document.write(
        `<div>何らかのエラーが発生しました。<br />時間をおいて再度実行してください。</div>`,
      );
    }
    newTab?.document.close();
  }, [error, logParameter]);

  return (
    <div>
      {loading && (
        <Overlay>
          <Loading />
        </Overlay>
      )}
      <Button
        className={className}
        disabled={disabled}
        onClick={handleGetLogParameter}
        margin={margin}
      >
        {children}
      </Button>
    </div>
  );
};
